import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as productActions from '../../product/product.actions';
import { getAllProductsByChannel } from '../../product/product.selectors';

import { ContentSection, ContentBlock } from '../components';
import Accordion, { AccordionHeader } from '../../common/components/Accordion';
import Table from '../../common/components/Table';
import Button from '../../../ui/button/Button';
import {ICONS as icons} from '../../../icons/Icons';
import Icon from '../../../icons/Icon';
import { partial } from '../../common/utils/partial';
import { formatProductDisplayName } from '../../../utils/content-utils';
import colors from '../../../utils/colors';
import { Localize } from '../../../locale/localization';

import { SalesBoostBlock } from '../../campaign/components';

class ScoreAdminPage extends Component {

  onEditClick = (id, event) => {
    event.stopPropagation();
    const { history } = this.props;
    history.push(`/admin/scores/edit/${id}`);
  }

  renderAccordionHeader = (name, id) => {
    return (
      <AccordionHeader>
        <h2>
          <Icon
            className="open"
            icon={icons.MINUS}
						width="20px"
						height="20px"
            stroke={colors.BRAND_RED}
          />
          <Icon
            className="closed"
            icon={icons.PLUS}
						width="20px"
						height="20px"
            stroke={colors.BRAND_RED}
          />
          <span className="title">
            {name}
          </span>
        </h2>
        <Button
          theme="light"
          onClick={partial(this.onEditClick, id)}
        >
          {Localize('scores.edit')}
        </Button>
      </AccordionHeader>
    );
  }

  renderProductHeader = () => {
    return (
      <tr>
        <th>Tuote</th>
        <th>Tyyppi</th>
        <th>Pisteitä / myynti</th>
      </tr>
    );
  }

  renderProductRow = (product) => {
    const {
      _id,
      productCategory,
      scoreEarned,
    } = product;

    const displayName = formatProductDisplayName(product);

    return (
      <tr key={_id}>
        <td>{productCategory.name}</td>
        <td>{displayName}</td>
        <td>{scoreEarned}</td>
      </tr>
    );
  }

  render() {
    const { productGroups } = this.props;
    return (
      <ContentSection>
        <SalesBoostBlock />
        <ContentBlock title={`${Localize('scores')}`}>
          {productGroups.map(group => (
            <Accordion
              key={group._id}
              renderHeaderContent={partial(this.renderAccordionHeader, group.name, group._id)}
            >
              <Table
                items={group.products}
                renderHeader={this.renderProductHeader}
                renderItem={this.renderProductRow}
              />
            </Accordion>
          ))}
        </ContentBlock>
      </ContentSection>
    );
  }
};

const mapStateToProps = (state) => {
  const productGroups = getAllProductsByChannel(state);
  return {
    productGroups,
  };
};

const ConnectedScoreAdminPage = connect(
  mapStateToProps,
  Object.assign({}, productActions)
)(ScoreAdminPage);

export default withRouter(ConnectedScoreAdminPage);


// WEBPACK FOOTER //
// ./src/modules/pages/admin/ScoreAdminPage.js